module.exports = __webpack_public_path__ + "img/support-secondary.d5fbe022.png";